import { atom } from 'recoil';
import defaultPoints from 'ProjectManager/Project/Introductions/Create/recoil/points/defaultPoints';

const pointsAtom = atom({
    key: 'projectManagement_introduction_create_points',
    default: defaultPoints,
});

export default pointsAtom;
